import type { PowerUpKind } from "../../sim";
import type { ImageKey } from "../assets";

/** Pod sprite and signature colour (minimap dot, HUD chip) of each power-up. */
export const POWER_UP_ART: Record<PowerUpKind, { texture: ImageKey; color: number }> = {
	tripleLaser: { texture: "pickupTriple", color: 0xff7a3d },
	warp: { texture: "pickupWarp", color: 0xb388ff },
	shield: { texture: "pickupShield", color: 0x58d68d },
	freeze: { texture: "pickupFreeze", color: 0x9fe8ff },
	extraMissiles: { texture: "pickupMissiles", color: 0x62e0ff },
	homing: { texture: "pickupHoming", color: 0xff4d5e },
	fuel: { texture: "pickupFuel", color: 0xf4c542 },
	repair: { texture: "pickupRepair", color: 0xff8fb1 },
};

/** Fueling stations (I-026): drawn as a dock with its range (viewport) and a square (minimap). */
export const FUEL_STATION_COLOR = 0x4dd0e1;
